import React, { useState } from 'react';
import './index.scss';

export interface LegendItem {
  key: string;
  label: string;
  color: string;
  icon?: string;
}

export interface MapLegendProps {
  title: string;
  items?: LegendItem[];
  children?: React.ReactNode;
  defaultCollapsed?: boolean;
  onToggle?: (collapsed: boolean) => void;
  className?: string;
}

const MapLegend: React.FC<MapLegendProps> = ({
  title,
  items,
  children,
  defaultCollapsed = false,
  onToggle,
  className,
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const handleToggle = () => {
    const newCollapsed = !collapsed;
    setCollapsed(newCollapsed);
    onToggle?.(newCollapsed);
  };

  return (
    <div
      className={`map-legend ${collapsed ? 'collapsed' : 'expanded'} ${className || ''}`}
    >
      <div className="legend-header">
        <span className="legend-title">{title}</span>
      </div>

      {!collapsed && (
        <div className="legend-content">
          {children
            ? children
            : items?.map((item) => (
                <div key={item.key} className="legend-item">
                  <div
                    className="legend-indicator"
                    style={{ backgroundColor: item.color }}
                  />
                  <span className="legend-label">{item.label}</span>
                </div>
              ))}
        </div>
      )}

      <div className="toggle-button" onClick={handleToggle}>
        <i className={`toggle-icon ${collapsed ? 'collapsed' : 'expanded'}`}>
          {collapsed ? '»' : '«'}
        </i>
      </div>
    </div>
  );
};

export default MapLegend;
